<template>
  <el-dialog top="8vh" :title="actionConfigInfo.label" :visible.sync="fileVisiable" width="80%"
             :close-on-click-modal="false" :before-close="handleCloseAction" :show-close="false">
    <div class="annexes-info">
      <div class="annexes">
        <el-upload 
          v-if="showRepeal"
          multiple 
          drag 
          class="upload-demo"
          :data="resData" 
          :show-file-list="false" 
          :on-success="onSuccess" 
          :on-error="onError"
          :before-upload="onProgress" 
          :headers="uploadHeaders" 
          :action="uploadUrl"
        >
          <i class="el-icon-upload"></i>
          <div class="el-upload__text"> {{ $t('FormOfSet.uploadDrag') }} <em>{{ $t('configMoudle.clickUpload') }}</em>
          </div>
        </el-upload>
      </div>
      <!-- 文件列表部分 -->
      <div class="annexes-content">
        <annexes-list
        :detailConfig="config"
        :height="400" :showDel="showDel" :tableData="annexesList" ref="annexesListRef"
          @bindAnnexesDownload="bindAnnexesDownload" @bindAnnexesDel="bindAnnexesDel"
          @bindAnnexesView="bindAnnexesView" />
      </div>
    </div>
    <div slot="footer">
      <el-button type="primary" size="small" @click="batchDownload">{{ $t('listOfSet.batchExport') }}</el-button>
      <el-button size="small" @click="handleClose">{{ $t('feedback.closed') }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { getSession } from "@/utils/methods";
import { commonMixin } from "../../mixins/commonMixin";
import AnnexesList from './AnnexesList.vue';
import { getFindLastAssignee, getAssociationPage, uploadAnnexFile, deleteAnnexFile, downloadAnnexFile } from '@/api/dynamicDetail';
export default {
  name: "FileUploadDialog",
  components: {
    AnnexesList
  },
  mixins: [commonMixin],
  props: {
    actionConfigInfo: {
      type: Object,
      required: true
    },
    iscopy: {
      type: Boolean,
      default: false
    },
    visible: {
      type: Boolean,
      default: false
    },
    curData: {
      type: Object,
      default: () => ({})
    },
    config: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      isScrollingManually: false,
      fileVisiable: false,
      showRepeal: true,
      uploadUrl: `${this.$baseUrl}/common/upload`,
      resData: {},
      // annexesList: [],
      showDel: true, // 控制附件上传选择框和删除按钮显示隐藏
      userName: JSON.parse(sessionStorage.getItem("userInfo")).user.username,
      permissions: JSON.parse(sessionStorage.getItem("userInfo")).permissions,
      // 角色权限控制新明细中的新增按钮
      permissionAddition: false,
      // 角色权限控制新明细中的复制单据按钮
      copyDocument: false,
      // 角色权限控制新明细中的打印按钮
      permissionPrinting: false,
      // 角色权限控制新明细中的提交按钮
      permissionSubmission: false,
      // 角色权限控制新明细中的删除按钮
      permissionDeletion: false,
      fileParam: [],
      uploadHeaders: {}
    };
  },
  watch: {
    async visible(val) {
      this.fileVisiable = val
      if (this.$route.query.id && !this.$route.query.copy) {
        await this.getRepeal();
      }
    },
    fileVisiable(val) {
      this.$emit('update:visible', val)
    },
    curData(val) {
      // if (val.id != null && !this.iscopy) {
      //   this.getAnnexList();
      // }

      if(!this.getId && val?.id) {
        this.$set(this.resData, 'id', val.id)
        this.getAnnexList()
      }
    },
    annexesList: {
      handler(val, oldVal) {
        if (JSON.stringify(val) === JSON.stringify(oldVal)) return; // ✅ 只有内容真的变了才触发
        this.curData['copyAnnexesList'] = val;
        this.$emit('update:formData', { ...this.curData });
      },
      deep: true,
      immediate: true
    }
  },
  created() {
    this.resData = {
      attachType: 1,
      id: this.getId || ''
    }
    if(this.getId && !this.iscopy) this.getAnnexList()
    this.uploadHeaders = { Authorization: getSession("vue_admin_template_token") }
  },
  computed: {
    getId() {
      return this.curData.id || null;
    }
  },
  mounted() {},
  methods: {
    handleClose() {
      this.handleCloseAction()
      this.fileVisiable = false
    },
    batchDownload() {
      const annexesList = this.$refs.annexesListRef.multipleSelection
      if (annexesList.length <= 0) {
        this.$message.warning(this.$t('configMoudle.downloadWithoutAttachments'))
        return
      }
      const that = this
      annexesList.forEach((item, i) => {
        setTimeout(() => {
          that.bindAnnexesDownload(item)
        }, i * 1000)
      })
    },
    getRepeal() {
      let that = this,
          username = this.userName,
          paths = this.$route.path,
          routeIndex = this.$route.name.indexOf("_"),
          routeNames = this.$route.name.substring(0, routeIndex),
          permissions = this.permissions,
          views = this.isView,
          query = this.$route.query,
          detailData = this.curData;
      this.showRepeal = true;
      this.showDel = true;
      this.permissionAddition = false;
      this.copyDocument = false;
      this.permissionDeletion = false;
      this.permissionSubmission = false;
      this.permissionPrinting = false;
      this.permissionExport = false;
      this.permissions.forEach(item => {
        if (item === paths + '.add') {
          this.permissionAddition = true;
          this.copyDocument = true;
        } else if (item === paths + '.delete') {
          this.permissionDeletion = true;
        } else if (item === paths + '.submit') {
          this.permissionSubmission = true;
        } else if (item === paths + '.print') {
          this.permissionPrinting = true;
        } else if (item === paths + '.edit') {
          this.permissionExport = true;
        }
      });
      //超级管理员不受权限控制
      if (this.permissions[0] === "*:*:*") {
        this.permissionAddition = true;
        this.copyDocument = true;
        this.permissionDeletion = true;
        this.permissionSubmission = true;
        this.permissionPrinting = true;
      }

      // 最外层条件 -- 根据当前登录角色是否拥有该模块的提交权限来同步赋予撤回权限

      if (!views && !paths.includes('add')) {
        if (that.permissionSubmission) {
          // 没有审批流程的，管理员、或者单据的创建人，可以撤回
          // 管理员账号时
          if (permissions[0] == "*:*:*") {
            // : 存在则代表无审批流
            console.log(views, that.permissionSubmission, detailData['process_instance_id'], 'viewsviews')
            if (detailData['process_instance_id'] && detailData['process_instance_id'].includes(':')) {
              // 先改成未设置审批流时管理员可以撤回所有
              if (detailData['placed'] == "2" && paths !== '/CW/sdrl_edit') {
                if (detailData['placed'] == username || that.permissionSubmission) {
                  that.showRepeal = true;
                }
              }
            } else {
              if (detailData['placed'] == "2") {
                const configId = query.configId
                if ((detailData['placed'] == username || detailData['update_by'] == username || that.permissionSubmission) && paths !== '/CW/sdrl_edit') {
                  that.showRepeal = true;
                  // 采购合同或者外销合同 审批完成的有变更按钮  所有不显示撤回按钮
                  if (configId === '1370293224182255617' || configId === '1369844364657954817') {
                    that.showRepeal = true;
                  }
                }
              }
            }
          } else {
            // placed不为0就代表进入了审批流
            if (detailData['placed'] !== "0") {
              // 当placed为字符（用户名）时，此单据进入审批中状态
              if (detailData['placed'] && detailData['placed'] !== "2" && detailData['placed'] !== "-1" && detailData['placed'] !== "0") {
                // 审批中状态时，单据最后更新人为当前用户时
                if (detailData['update_by'] == username) that.showRepeal = true;
              }
              // 审批完成状态时
              if (detailData['placed'] == "2") {
                const configId = query.configId
                // 未设置审批流且单据创建人为当前用户时
                if ((detailData['process_instance_id'] || '').includes(':')) {
                  if (detailData['create_by'] == username || that.permissionSubmission || detailData['update_by'] == username) that.showRepeal = true;
                  // 采购合同或者外销合同 审批完成的有变更按钮  所有不显示撤回按钮
                  if (configId === '1370293224182255617' || configId === '1369844364657954817') {
                    that.showRepeal = true
                  }
                } else {
                  console.log('detailData2222', detailData)
                  // 已审批时状态时, 判断最终审批人是否是当前用户
                  getFindLastAssignee({ processInstanceId: detailData?.process_instance_id || 'undefined' }).then(res => {
                    that.showRepeal = res.isFinal;
                  })
                }
              }
            }
          }
        }
      } else {
        console.log('detailData33333', detailData)
        // 从已审批进入详情页时
        getFindLastAssignee({ processInstanceId: detailData?.process_instance_id || 'undefined' }).then(res => {
          if (res.isFinal && query?.['signs'] == 'successApproval') that.showRepeal = true;
        })
      }

      if (this.curData.placed !== '0' && this.curData.placed !== '-1' && this.config.permAttachOfPlaced === 2) {
        this.showRepeal = false
      }

      if (this.curData.placed !== '0' && this.curData.placed !== '-1' && that.config.permAttachOfPlaced === 3) {
        that.showDel = false;
      }
    },
    // 附件列表
    getAnnexList(annexList) {
      const params = {
        pageNum: 1,
        pageSize: 99999,
        associationId: this.getId || this.curData.id
      }
      if (annexList) {
        this.annexesList = annexList
      } else if (this.getId) {
        getAssociationPage(params).then(res => {
          this.annexesList = res.result;
        })
      }
    },
    // 关闭处理函数
    handleCloseAction() {
      this.$emit('update:visible', false)
      this.$emit('bindAnchor', this.annexesList)
    },

    // 成功上传处理函数
    onSuccess(response) {
      this.$message.success(this.$t('configMoudle.uploadSuccess'))
      this.annexesList.push(response.data)
      this.uploadLoading.close()
      if (this.getId) {
        this.getAnnexList()
      }
    },

    // 上传错误处理函数
    onError(error) {
      setTimeout(() => {
        this.uploadLoading.close()
      }, 1000);
    },

    // 上传进度
    onProgress(file) {
      const extension = file.name.substr(file.name.lastIndexOf('.') + 1).toLowerCase();
      if (extension === "jpg" || extension === "jpeg" || extension === "jpe" || extension === "png" || extension === "pns") {
        this.resData.attachType = 10
      } else {
        this.resData.attachType = 1
      }
      if (this.getId) {
        this.resData.id = this.getId
      }
      this.uploadLoading = this.$loading({
        lock: true,
        text: '上传中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
    },
    //重新默认上传实现
    uploadALLFile(param) {
      this.fileParam.push(param)


      // for (let i = 0; i < this.fileParam.length; i++) {
      //   if (!this.fileParam[i].type) {
      //     const file = this.fileParam[i].file;
      //     //发送请求的参数格式为FormData
      //     const formData = new FormData();
      //     formData.append("file", file);
      //     formData.append("id", this.getId || '');
      //     const extension = file.name.substr(file.name.lastIndexOf('.') + 1).toLowerCase();
      //     if (extension === "jpg" || extension === "jpeg" || extension === "jpe" || extension === "png" || extension === "pns" || extension === "gif") {
      //       formData.append("attachType", 10);
      //     } else {
      //       formData.append("attachType", 1);
      //     }
      //     uploadAnnexFile(formData).then(res => {
      //       this.$message.success(this.$t('configMoudle.uploadSuccess'))
      //       this.fileParam[i].type = 1
      //       if (!this.getId) {
      //         this.annexesList.push(res)
      //       }

      //       param.onSuccess(res)
      //     }).catch(err => {
      //       this.$message.error(err.message || this.$t('configMoudle.uploadFail'))
      //       param.onError(err.message || this.$t('configMoudle.uploadFail'))
      //     })
      //   }

      // }


    },

    // 下载文件
    bindAnnexesDownload(row) {
      downloadAnnexFile(row.id).then(res => {
        let link = document.createElement("a");
        link.style.display = "none";
        link.href = URL.createObjectURL(new Blob([res.data]));
        link.download = row.realAttachName || row.real_attach_name;
        document.body.appendChild(link);
        link.click();
        URL.revokeObjectURL(link.href);
        document.body.removeChild(link);
      })
    },
    // 附件删除
    bindAnnexesDel(row) {
      if (!this.curData.id) {
        this.annexesList.forEach((item, index) => {
          if (item.id == row.id) this.annexesList.splice(index, 1)
        })
        return
      }
      deleteAnnexFile(row.id).then(res => {
        this.$message.success(this.$t('Emails.delSuccess'))
        this.annexesList.forEach((item, index) => {
          if (item.id == row.id) this.annexesList.splice(index, 1)
        })
      }).catch(err => {
        this.$message.error(this.$t('Emails.delFail'))
      })
    },
    b64EncodeUnicode(str) {
      // first we use encodeURIComponent to get percent-encoded UTF-8,
      // then we convert the percent encodings into raw bytes which
      // can be fed into btoa.
      return btoa(encodeURIComponent(str).replace(/%([0-9A-F]{2})/g, function (match, p1) {
        return String.fromCharCode('0x' + p1);
      }));
    },
    bindAnnexesView(row) {
      let onlinePreviewUrl = window.onlinePreviewUrl;
      if (row.accessUrl) {
        let startIndex = row.accessUrl.lastIndexOf(".")
        let str = row.accessUrl.substring(startIndex + 1, row.accessUrl.length)
        if (str == 'jpeg' || str == 'pdf' || str == 'png' || str == 'jpg' || str == 'jpe' || str == 'pns') {
          let link = document.createElement("a");
          link.href = row.accessUrl;
          link.target = "_blank";
          link.click();
        } else {
          if (onlinePreviewUrl) {
            var modifiedUrl = row.accessUrl.replace(/\\/g, "/");
            var b64Encoded = this.b64EncodeUnicode(modifiedUrl);
            let link = document.createElement("a");
            link.href = onlinePreviewUrl + '?url=' + encodeURIComponent(b64Encoded);
            link.target = "_blank";
            link.click();
          } else {
            this.$message('文件预览服务未部署!')
          }
        }
      }
    }
  }
};
</script>

<style scoped>
.annexes-info {
  display: flex;
  margin: -10px;
  justify-content: space-between;
  height: 500px;
  width: 100%;
  overflow-y: hidden;
}

.annexes {
  /deep/ .el-upload-dragger {
    height: 132px;
    width: 100%;

    .el-icon-upload {
      margin: 26px 0 10px;
      line-height: 33px;
    }
  }

  .upload-demo {
    width: 360px;

    /deep/ .el-upload__text {
      font-size: 18px;
    }

    /deep/ .el-upload__tip {
      font-size: 18px;
      text-align: center;
    }
  }
}

.annexes-content {
  flex: 1;
  margin-left: 10px;
}
</style>
